import axios from 'axios';
import React from 'react';
import Select from 'react-select/async';

class CategorySelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      categories: [],
    };

    this.search = this.search.bind(this);
  }
  componentDidMount() {
    axios.get('/api/product-data/categories').then((response) => {
      this.setState({
        categories: response.data.data.map(category => ({
          label: category.name, value: category.id,
        })),
      });
    });
  }
  search(text, callback) {
    axios.get(`/api/product-data/categories?search=${text}`).then((response) => {
      callback(response.data.data.map(category => ({
        label: category.name, value: category.id,
      })));
    });
  }
  render() {
    return (
      <div>
        <label>
          Please select a category:
          <Select defaultOptions={this.state.categories} loadOptions={this.search} />
        </label>
      </div>
    );
  }
}

export default CategorySelector;
